import { render, staticRenderFns } from "./ActionTemplateTray.vue?vue&type=template&id=3b1f4853&scoped=true&"
import script from "./ActionTemplateTray.vue?vue&type=script&lang=js&"
export * from "./ActionTemplateTray.vue?vue&type=script&lang=js&"
import style0 from "./ActionTemplateTray.vue?vue&type=style&index=0&id=3b1f4853&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1f4853",
  null
  
)

export default component.exports